import axios from "axios";

import APIRoutes from "../../APIRoutes";

import SonicApplication from "../../../common/classes/SonicApplication";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postUpdateApplication
 *
 * Update application project data.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param is_jikei_request Whether the request is from jikei or not.
 * @param application_id ID or array of IDs of the application information you wish to update
 * @param applicant_id ID or array of IDs of the applicant information you wish to update
 * @param status Status of the offer information you wish to update.
 * @param memo Whether or not results are ascending or descending
 * @returns Updated applications.
 */

export const postUpdateApplication = async (
  auth_token: string,
  is_jikei_request: boolean,
  application_id: string,
  status?: string,
  memo?: string,
  send_mail?: boolean
) => {
  const request_url = is_jikei_request
    ? getAPIRoot(APIRoutes.post.applications, "jikei")
    : getAPIRoot(APIRoutes.post.applications, "admin");

  try {
    const res = await axios.post(
      request_url,
      {
        sonic_application_id: application_id,
        sonic_status: status,
        sonic_memo: memo,
        sonic_send_mail: send_mail,
      },
      {
        headers: {
          "X-Sonic-Auth": auth_token,
        },
      }
    );

    if (res.data.result !== true || res.data.message === null) return null;
    // update application
    const applications: Array<SonicApplication> = [];
    const a = res.data.message.entry;

    const application = SonicApplication.parseFromAPIResponse(a);

    applications.push(application);

    return applications;
  } catch (e) {
    return null;
  }
};
